export const marketingConsentPartnersDK = [
  'Axofinans',
  'TaxHelper',
  'Tryg Forsikring',
  'uscore',
  'Købstædernes Forsikring',
];
